var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-dialog',{attrs:{"show":_vm.show,"width":320,"button1-text":"OK"},on:{"button1Pressed":_vm.onOk}},[_vm._v(" "+_vm._s(_vm._f("translate")('releases.editing.warning'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }